module.exports = new __parcel__URL__("33560_h.579bf6d2.jpg").toString();